import { PropsWithChildren } from 'react'

export const ViewModeShell = ({ children }: PropsWithChildren) => {
  return (
    <div className='w-256 px-5'>
      <div className='pr-1 text-black'>{children}</div>
    </div>
  )
}

export default ViewModeShell
